
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.134 18.158"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19944","data-name":"Path 19944","d":"M17.384 10.958a1.837 1.837 0 01-1.834 1.834h-1.48v3.46a1.156 1.156 0 01-1.156 1.156H9.246v-1.5a1.836 1.836 0 00-3.671 0v1.5H1.904a1.155 1.155 0 01-1.153-1.156v-3.46h1.323a1.834 1.834 0 000-3.668H.751V5.245a1.155 1.155 0 011.153-1.156h3.671v-1.5a1.836 1.836 0 013.671 0v1.5h3.668a1.156 1.156 0 011.156 1.156V9.12h1.48a1.833 1.833 0 011.834 1.838z","fill":"none","stroke":"#5a677d","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    